var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateEqualTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9596 12.008C14.8236 12.4 14.6116 12.708 14.3236 12.932C14.0356 13.156 13.7076 13.268 13.3396 13.268C13.0996 13.268 12.8636 13.224 12.6316 13.136C12.3996 13.048 12.1196 12.92 11.7916 12.752C11.5196 12.616 11.3156 12.52 11.1796 12.464C11.0436 12.408 10.9076 12.38 10.7716 12.38C10.3396 12.38 10.0356 12.636 9.85964 13.148L9.05564 12.632C9.19164 12.24 9.40364 11.932 9.69164 11.708C9.97964 11.484 10.3076 11.372 10.6756 11.372C10.9236 11.372 11.1596 11.416 11.3836 11.504C11.6156 11.592 11.8916 11.716 12.2116 11.876C12.4756 12.004 12.6796 12.1 12.8236 12.164C12.9676 12.22 13.1076 12.248 13.2436 12.248C13.4676 12.248 13.6516 12.188 13.7956 12.068C13.9396 11.94 14.0596 11.752 14.1556 11.504L14.9596 12.008ZM14.9596 14.432C14.8236 14.824 14.6116 15.132 14.3236 15.356C14.0356 15.58 13.7076 15.692 13.3396 15.692C13.0996 15.692 12.8636 15.648 12.6316 15.56C12.3996 15.472 12.1196 15.344 11.7916 15.176C11.5196 15.04 11.3156 14.944 11.1796 14.888C11.0436 14.832 10.9076 14.804 10.7716 14.804C10.3396 14.804 10.0356 15.06 9.85964 15.572L9.05564 15.056C9.19164 14.664 9.40364 14.356 9.69164 14.132C9.97964 13.908 10.3076 13.796 10.6756 13.796C10.9236 13.796 11.1596 13.84 11.3836 13.928C11.6156 14.016 11.8916 14.14 12.2116 14.3C12.4756 14.428 12.6796 14.524 12.8236 14.588C12.9676 14.644 13.1076 14.672 13.2436 14.672C13.4676 14.672 13.6516 14.612 13.7956 14.492C13.9396 14.364 14.0596 14.176 14.1556 13.928L14.9596 14.432Z",
    fill: "#1D6295"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1L6 6",
    stroke: "#1D6295",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1L18 6",
    stroke: "#1D6295",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateEqualTo);
export default __webpack_public_path__ + "static/media/date_equal_to.787a71431f3c5af558ac7258e4bba198.svg";
export { ForwardRef as ReactComponent };